import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TITLE_BY_PATH = {
  '/dashboard': 'nav.dashboard',
  '/trainings': 'nav.trainings',
  '/matches': 'nav.matches',
  '/progress': 'nav.progress',
  '/schedule': 'nav.schedule',
  '/profile': 'nav.profile',
  '/training/planner': 'nav.aiPlanner',
  '/fitness': 'nav.fitness',
  '/nutrition': 'nav.nutrition',
  '/equipment': 'nav.equipment',
  '/achievements': 'nav.achievements',
  '/notifications': 'nav.notifications',
  '/subscription': 'nav.subscription',
  '/courts': 'nav.courts',
  '/opponents': 'nav.opponents',
  '/matchmaking': 'nav.matchmaking',
  '/tournaments': 'nav.tournaments',
  '/clubs': 'nav.clubs',
  '/feed/global': 'nav.feed',
};

export const DesktopHeader = ({ title, actions = null }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const resolvedTitle = useMemo(() => {
    if (title) return title;
    const translationKey = location.pathname.startsWith('/events/') && location.pathname.endsWith('/feed')
      ? 'nav.feed'
      : TITLE_BY_PATH[location.pathname];
    return translationKey ? t(translationKey) : 'Tennis Diary';
  }, [location.pathname, t, title]);

  return (
    <header className="td-desktop-header">
      <h1 className="td-desktop-title">{resolvedTitle}</h1>
      <div className="td-desktop-actions">{actions}</div>
    </header>
  );
};
